import _ from "lodash";

const initialState = {
  entities: {},
  fetchStatuses: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ENTITIES/PROJECTS/RECEIVED":
      const itemsBeforeMap = action.items;
      let itemsObject = {};
      _.map(itemsBeforeMap, (project, i) => {
        // return {
        //   ...project,
        //   rooms: _.get(project, 'rooms')
        // }
        itemsObject[_.get(project, "id")] = {
          ...project,
          rooms: _.get(project, "rooms"),
        };
      });
      localStorage.clear();
      return {
        ...state,
        entities: itemsObject,
      };
    case "ENTITIES/PROJECTS/UPDATE":
      localStorage.clear();
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.id]: {
            ...state.entities[action.id],
            ...action.data,
          },
        },
      };
    case "ENTITIES/PROJECTS/REPLACE":
      localStorage.clear();
      return {
        ...state,
        entities: action.items,
      };
    case "ENTITIES/PROJECTS/DELETE":
      localStorage.clear();
      return {
        ...state,
        entities: _.omit(state.entities, [action.id]),
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/projects.js